import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
@Component({
  selector: 'sm-all-inventory-status',
  templateUrl: './all-inventory-status.component.html',
  styleUrls: ['./all-inventory-status.component.scss']
})
export class AllInventoryStatusComponent implements OnInit, OnDestroy {

  inventoryStatusData: any = []
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  pageNo:number = 1
  constructor(private loaderservice: LoaderServiceService,private navservice:NavigationService,private _apiservice:ApiService) {this.navservice.hideSidebarAndNav=false
    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType == SM_CONSTANTS.RESULT_API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD){
        this.inventoryStatusData = []
        if(resdata.result){
          this.inventoryStatusData = resdata.result
          this.inventoryStatusData.forEach((element:any) => {
            element.stock = element.current_purchase_stock + ' ' + (element.purchase_unit ? element.purchase_unit : '')
            element.s_q_info = element.quantity_info + ' ' + (element.selling_unit ? element.selling_unit : '')
          });
        }
        this.loaderservice.showLoader = false
        this.loader = false
      }
    })
   }

  ngOnInit(): void {
    this.loader = true
    this.loaderservice.showLoader = true
    this._apiservice.getLatestInventoryStatusForDashboard('500',this.pageNo);
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];
  
  bookingData = [
    { image: 'https://m.media-amazon.com/images/I/81lT4bobboL._AC_UF894,1000_QL80_.jpg', name: 'Towel', quanty: '1 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216',  stock:'0 Unit' },
    { image: 'https://www.fashioncolour.in/cdn/shop/products/FC_Platinum_Nail_Polish_Shade_121.jpg?v=1668152534', name: 'Nail polishes', quanty: '20 ml bottle', shop: 'Mithali Hair Spa',  location: 'Durgapur, West Bengal 713216',  stock:'0 Bottle' },
    { image: 'https://m.media-amazon.com/images/I/61nBCO3LpfL.jpg', name: 'Combs', quanty: '1 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216',  stock:'4 Unit' },
 
  ];


  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "item_name"
    },
    {
      columnName: "quantity info",
      columnProperty: "quantity_info"
    },
    {
      columnName: "shop",
      columnProperty: "name"
    },
    {
      columnName: "location",
      columnProperty: "address_line"
    },
    {
      columnName: "stock",
      columnProperty: "stock"
    }
  ];
ngOnDestroy(): void {
  this._apisub.unsubscribe()
}
}
